import { CSSProperties } from "react";

export const ColumnStyles = {
  statusChips: {
    completed: {
      backgroundColor: "#e8f5e8",
      color: "#2e7d32",
      borderColor: "#4caf50",
    },
    failed: {
      backgroundColor: "#ffebee",
      color: "#d32f2f",
      borderColor: "#f44336",
    },
    pending: {
      backgroundColor: "#fff3e0",
      color: "#f57c00",
      borderColor: "#ff9800",
    },
    processing: {
      backgroundColor: "#e3f2fd",
      color: "#1976d2",
      borderColor: "#2196f3",
    },
    inDevelopment: {
      backgroundColor: "#f3e5f5",
      color: "#7b1fa2",
      borderColor: "#9c27b0",
    },
    default: {
      backgroundColor: "#f5f5f5",
      color: "#757575",
      borderColor: "#bdbdbd",
    },
  },
  statusIcon: {
    fontSize: "14px",
    marginRight: "4px",
  } as CSSProperties,
  chipContainer: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  } as CSSProperties,
  statusChip: {
    minWidth: "100px",
    height: "24px",
    fontSize: "0.75rem",
    fontWeight: 500,
  },
  detailsContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    borderLeft: "1px solid",
    borderRight: "1px solid",
  } as CSSProperties,
  detailsButton: {
    padding: "4px",
    borderRadius: "4px",
  },
  measureContainer: {} as CSSProperties,

  headerContainer: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    position: "relative",
  } as CSSProperties,

  headerText: {
    flex: 1,
    userSelect: "none",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    paddingRight: "28px",
    display: "flex",
    alignItems: "center",
  } as CSSProperties,

  headerMenuButton: {
    position: "absolute",
    right: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "24px",
    height: "24px",
    cursor: "pointer",
    borderRadius: "4px",
    transition: "background-color 0.2s",
    border: "none",
    background: "#fff",
    padding: 0,
    outline: "none",
  } as CSSProperties,

  headerIconButton: {
    padding: "2px",
    marginLeft: "4px",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.04)",
    },
  },

  formControlLabel: {
    margin: 0,
    width: "100px",
  },

  cropChip: {},
};
